import { Card } from "react-bootstrap";

const FeatureCard = ({
  icon: IconComponent,
  title,
  description,
}) => {
  return (
    <Card className="feature-card h-100">
  <Card.Body className="d-flex align-items-start p-3">
    
    <div className="icon-box me-2">
      <IconComponent size={20} />
    </div>

    <div>
      <Card.Title className="feature-title h6">
        {title}
      </Card.Title>
      <Card.Text className="feature-text">
        {description}
      </Card.Text>
    </div>

  </Card.Body>
</Card>

  );
};

export default FeatureCard;
